import { Link } from '@tanstack/react-router'

import { L, Note, P, Ul } from '@/features/guide/prose'

export function CreateRestaurantEn() {
  return (
    <>
      <P>
        Go to romi.io.vn and log in. If you do not have an account yet, register first: enter your phone number or email, press <L k="auth.sendCode" />,
        type the code you receive (valid for 10 minutes), set a password and press <L k="auth.createAccount" />.
      </P>
      <P>
        Press <L k="landing.createRestaurant" /> on the home page, or open <L k="nav.myRestaurants" /> from the user icon in the top right corner and press{' '}
        <L k="backOffice.create" /> there. One account can set up one restaurant by itself; contact Romi to add more.
      </P>
      <Ul>
        <li>
          <L k="restaurants.name" />: the real name of your restaurant.
        </li>
        <li>
          <L k="restaurants.slug" />: generated from the name, and you can edit it. It is your restaurant’s web address, it must not match another restaurant on
          Romi (the form warns you), and it cannot be changed later.
        </li>
        <li>
          <L k="restaurants.color" />: the accent color of your restaurant’s pages.
        </li>
        <li>
          <L k="restaurants.mainLanguage" />: the restaurant’s main language. It starts as the language you are using Romi in.
        </li>
        <li>
          <L k="restaurants.secondaryLanguages" />: any other languages the restaurant wants to support (optional).
        </li>
        <li>
          <L k="restaurants.branchName" />: every restaurant needs at least one branch. Name it as you like (Main, 1, District 1, …).
        </li>
        <li>
          <L k="restaurants.branchSlug" />: generated from the branch name, and you can edit it. It is part of the branch’s web address and must be unique within
          your restaurant.
        </li>
        <li>
          <L k="restaurants.timezone" />: the branch’s time zone, prefilled from your device. Type to search the list; each zone shows its GMT offset.
        </li>
        <li>
          <L k="restaurants.currency" />: the currency used at the branch. It follows the time zone’s country (Asia/Ho_Chi_Minh gives VND) until you pick one
          yourself; type a code or name to search.
        </li>
      </Ul>
      <P>
        Press <L k="backOffice.create" /> and the restaurant is yours. You land on its <L k="nav.branches" /> page, and Romi is notified so we can help with the
        setup. Two more steps, <Link to="/app/guide/$guide" params={{ guide: 'setup-restaurant' }} className="text-accent-ink underline">restaurant setup</Link> and{' '}
        <Link to="/app/guide/$guide" params={{ guide: 'setup-branch' }} className="text-accent-ink underline">branch setup</Link>, and you are ready to operate.
      </P>
      <Note>
        Ready to start? <Link to="/app/restaurants/new" className="underline">Create your restaurant</Link>.
      </Note>
    </>
  )
}
